const map = {
	"./global/app-content/app-content.riot": 9435,
	"./global/app-main/app-main.riot": 7747,
	"./includes/aside-menu/aside-menu.riot": 7435,
	"./includes/pages/about/about.riot": 1874,
	"./includes/pages/absensi/absensi-input-form/absensi-input-form.riot": 6574,
	"./includes/pages/absensi/absensi-input/absensi-input.riot": 4946,
	"./includes/pages/absensi/absensi-table/absensi-table.riot": 4310,
	"./includes/pages/absensi/absensi-transfer-form/absensi-transfer-form.riot": 4518,
	"./includes/pages/absensi/rekap/rekap-chart.riot": 2511,
	"./includes/pages/absensi/rekap/rekap-klasikal.riot": 8035,
	"./includes/pages/absensi/rekap/rekap.riot": 9506,
	"./includes/pages/administration/administration.riot": 5372,
	"./includes/pages/home/home.riot": 4018,
	"./includes/pages/login/login.riot": 5070,
	"./includes/pages/password/change-password.riot": 5727,
	"./includes/pages/platform/platform-schools.riot": 230,
	"./includes/pages/setup/setup.riot": 3830,
	"./includes/pages/students/students.riot": 2580,
	"./includes/toast/toast.riot": 7149
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3676;